<template>
    <div class="next-step-filled-items">
        <span class="attribute-label" v-if="isLocalizedAttribute()">{{ $t(`chatbotv2.attr.${attribute}`) }}</span>
        <span v-else-if="attribute.startsWith('contact_property_')">
            {{ visitorContactAttributes[attribute.replace("contact_property_", "")] }}
        </span>
        <span class="attribute-label" v-else>{{ attribute }}</span>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import CONFIG from "../../../../../../../config/config";
import systemAttributes from "../../../../utils/systemAttributes";
import { mapState } from "vuex";

const log = log2("AttributeLabel");
export default {
    name: "AttributeLabel",
    props: {
        attribute: {
            type: String,
            required: true,
        },
    },
    components: {},
    data() {
        return {
            CONFIG,
        };
    },
    computed: {
        ...mapState({
            visitorContactAttributes: (state) =>
                (state.contactProperty.data || []).reduce((a, b) => {
                    a[b._id] = b.label;
                    return a;
                }, {}),
        }),
    },
    methods: {
        getContent() {
            const attributeName = "";
            if (attributeName === "akinon_order_id") return "Order ID";
            else return attributeName;
        },
        isLocalizedAttribute() {
            return (
                this.isAkinonAttribute() ||
                this.isIdeasoftAttribute() ||
                this.isProbelAttribute() ||
                this.isB2CargoAttribute() ||
                this.isHolidayPlusAttribute() ||
                this.isSystemAttribute()
            );
        },
        isAkinonAttribute() {
            return this.attribute.startsWith("akinon");
        },
        isIdeasoftAttribute() {
            return this.attribute.startsWith("ideasoft");
        },
        isProbelAttribute() {
            return this.attribute.startsWith("probel");
        },
        isB2CargoAttribute() {
            return this.attribute.startsWith("b2cargo");
        },
        isHolidayPlusAttribute() {
            return this.attribute.startsWith("holiday_plus");
        },
        isSystemAttribute() {
            return !!systemAttributes.find((x) => x.value === this.attribute);
        },
    },
};
</script>

<style scoped lang="scss">
.next-step-filled-items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 20px;
    width: fit-content;
    margin-right: 3px;

    .attribute-label {
        font-weight: 600;
        font-size: 14px;
    }
}
</style>
